import 'moment-timezone';
import React, { Component } from 'react';
import Moment from 'react-moment';
import { customFetchV2 } from '../../../services/custom-fetch-v2.ts';
import Loading from '../Loading.jsx';
import SectionHeader from './SectionHeader.tsx';

class BillingPaymentHistory extends Component {
  state = {
    isLoading: true,
    payments: [],
  };

  renderPaymentRows = payments => payments.map((payment, ix) => (
    <PaymentRow key={ix} payment={payment}/>
  ));

  componentDidMount() {
    this.loadPaymentHistory();
  }

  loadPaymentHistory = () => {
    this.setState({
      isLoading: true,
    });

    customFetchV2('/api/billing/payment-history', {
      method: 'GET',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Ooops');
        }

        return response.data;
      })
      .then((json) => {
        this.setState({
          isLoading: false,
          payments: json,
        });
      })
      .catch((error) => {
        this.setState({
          errorMsg: error.message,
          isLoading: false,
        });
      });
  };

  renderContent() {
    if (this.state.isLoading) {
      return <Loading/>;
    }

    return (
      <table className="table is-striped is-hoverable is-fullwidth">
        <thead>
          <tr>
            <th>ID</th>
            <th>Date</th>
            <th className="is-hidden-mobile">Payment Method</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {this.renderPaymentRows(this.state.payments)}
        </tbody>
      </table>
    );
  }

  render() {
    return (
      <div className="section">
        <SectionHeader title='Payment History' />
        {this.renderContent()}
      </div>
    );
  }
}

function PaymentRow(props) {
  const {
    id, date, cardDescription, chargedAmount,
  } = props.payment;

  return (
    <tr>
      <td>{id}</td>
      <td>
        <Moment date={date} format="YYYY-MM-DD" />
      </td>
      <td className="is-hidden-mobile">{cardDescription}</td>
      <td>&#36;{chargedAmount.toFixed(2)}</td>
    </tr>
  );
}

export default BillingPaymentHistory;
